<template>
  <div>
    <div
      v-if="submitClicked"
      class="overlay"
      :class="{ active: submitClicked && show }"
    ></div>
    <md-snackbar
      md-position="center"
      :md-duration="Infinity"
      :md-active.sync="show"
      md-persistent
    >
      <span>{{ dirty ? preSbmtMsg : postSbmtMsg }}</span>
      <md-button
        id="snackbar-submit"
        v-if="dirty"
        class="md-primary"
        @click="submit()"
        :disabled="submitClicked"
        color="secondary"
        data-tour="submit"
      >
        <md-progress-spinner
          v-if="submitClicked"
          class="md-accent"
          :md-diameter="18"
          :md-stroke="2"
          md-mode="indeterminate"
        ></md-progress-spinner>
        <span v-else>Submit</span>
      </md-button>
    </md-snackbar>
  </div>
</template>
<script>
export default {
  data: () => ({
    preSbmtMsg: "You have made some changes. Click SUBMIT to save them.",
    showSubmitTimeout: null,
    showSubmitTimeoutInterval: 2000,
    show: false,
    submitClicked: false
  }),
  props: {
    dirty: Boolean,
    errorsOccurred: null,
    validationError:Boolean
  },
  methods: {
    submit: function() {
      this.submitClicked = true;
      this.$emit("submit");
      if (this.validationError){
        this.show = true;
        this.submitClicked = false;
      }
    }
  },
  computed: {
    postSbmtMsg: function() {
      return "Your changes have been saved.";
    }
  },
  watch: {
    dirty: function(newValue) {
      var me = this;
      if (!newValue) {
        if (this.submitClicked) {
          // Not dirty and the use clicked the submit button: show the user their submit worked for a small interval.
          me.showSubmitTimeout = setTimeout(function() {
            me.show = false;
          }, me.showSubmitTimeoutInterval);
        } else {
          me.show = false;
        }
      } else {
        // Dirty: clear any timeout to ensure the submit
        // bottom sheet is not closed out when it shouldn't be.
        me.show = true;
        me.submitClicked = false;
        clearTimeout(me.showSubmitTimeout);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.overlay {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: 1060;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.overlay.active {
  display: flex;
}
.md-snackbar {
  min-height: 55px;
  .md-snackbar-content {
    span {
      font-size: 14px;
    }
    button {
      /deep/ .md-button-content {
        min-width: 55px;
        .md-progress-spinner {
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
